import { render } from "./input-auto.html?vue&type=template&id=65946ab1&scoped=true&ts=true"
import script from "./input-auto.ts?vue&type=script&lang=ts"
export * from "./input-auto.ts?vue&type=script&lang=ts"

import "./input-auto.scss?vue&type=style&index=0&id=65946ab1&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65946ab1"]])

export default __exports__